<app-user-dashboard [fullScreen]="true" [userMenuActiveItemIndex]="0" [activeItem]="'marketplace'">
  <div class="bg-container custom-tabview">
    <p-tabView (onChange)="switchHeaders($event);" [(activeIndex)]="tabIndex">
      <p-tabPanel #fruitStand header="Fresh fruit">
        <div class="marketplace-filters-container">
          <div class="grid">
            <div class="col-12 md:col-6 lg:col-6 pb-0">
              <form [formGroup]="portFormGroup">
                <div class="p-fluid grid">
                  <div class="col-12 md:col-6 lg:col-4">
                    <span class="p-float-label">
                      <p-dropdown
                        [options]="originCountries"
                        id="countryFromId"
                        formControlName="countryFromId"
                        optionLabel="name"
                        optionValue="id"
                        (onChange)="loadExportOffers()"
                        (onClear)="clearSpotSearchParams()"
                        [filter]="true"
                        filterBy="name"
                        [showClear]="true"
                        placeholder="{{'MarketplacePage.Spot.ImportFromFieldPlaceholder' | translate}}"
                        class="p-inputtext-sm custom-dropdown bg-form">
                        <ng-template pTemplate="selectedItem">
                          <div class="flex align-items-center gap-2" *ngIf="selectedCountryFrom">
                            <img [flag]="selectedCountryFrom.code" class="country-img-select" alt="flag"/>
                            <div>{{ selectedCountryFrom | countryDescription }}</div>
                          </div>
                        </ng-template>
                        <ng-template let-country pTemplate="item">
                          <div class="flex align-items-center gap-2">
                            <img [flag]="country" class="country-img-select" alt="flag"/>
                            <div >{{ country | countryDescription }}</div>
                          </div>
                        </ng-template>
                      </p-dropdown>
                      <label for="countryFromId" class="export-from-label">
                        {{'MarketplacePage.Spot.ImportFromFieldPlaceholder' | translate}}
                      </label>
                    </span>
                  </div>
                  <div class="col-12 md:col-6 lg:col-4">
                    <span class="p-float-label">
                      <p-dropdown
                        [options]="destinationCountries"
                        id="countryToId"
                        formControlName="countryToId"
                        optionLabel="name"
                        optionValue="id"
                        (onChange)="loadDestinationPorts()"
                        [filter]="true"
                        filterBy="name"
                        [showClear]="false"
                        placeholder="{{'MarketplacePage.Spot.ImportToFieldPlaceholder' | translate}}"
                        class="p-inputtext-sm custom-dropdown bg-form">
                        <ng-template pTemplate="selectedItem">
                          <div class="flex align-items-center gap-2" *ngIf="selectedCountryTo">
                            <img [flag]="selectedCountryTo.code" class="country-img-select" alt="flag"/>
                            <div>{{ selectedCountryTo | countryDescription }}</div>
                          </div>
                        </ng-template>
                        <ng-template let-country pTemplate="item">
                          <div class="flex align-items-center gap-2">
                            <img [flag]="country" class="country-img-select" alt="flag"/>
                            <div> {{ country | countryDescription }}</div>
                          </div>
                        </ng-template>
                      </p-dropdown>
                      <label for="countryToId" class="export-from-label">
                        {{'MarketplacePage.Spot.ImportToFieldPlaceholder' | translate}}
                      </label>
                    </span>
                  </div>
                  <div class="col-12 md:col-6 lg:col-4">
                    <span class="p-float-label">
                      <p-dropdown
                        [options]="destinationPorts"
                        id="portToId"
                        formControlName="portToId"
                        optionLabel="name"
                        optionValue="id"
                        (onChange)="loadEstimations()"
                        [filter]="true"
                        filterBy="name"
                        [showClear]="false"
                        placeholder="{{'MarketplacePage.Spot.ToPortFieldLabel' | translate}}"
                        emptyMessage="{{'MarketplacePage.Spot.EmptyResultsText' | translate}}"
                        class="p-inputtext-sm custom-dropdown bg-form"/>
                        <label for="portToId" class="export-from-label">
                          {{'MarketplacePage.Spot.ToPortFieldLabel' | translate}}
                        </label>
                      </span>
                  </div>
                  <div class="col-12 md:col-12 lg:col-4">
                    <p-fieldset class="estimation-field" legend="{{'MarketplacePage.Spot.NavyListLabel' | translate}}">
                      <ng-container *ngFor="let e of estimations">
                        <div class="flex flex-column">
                          <span class="estimation-text">{{e.shippingCompany.name}}</span>
                        </div>
                      </ng-container>
                    </p-fieldset>
                  </div>
                  <div class="col-12 md:col-12 lg:col-4">
                    <p-fieldset class="estimation-field" legend="{{'MarketplacePage.Spot.TimeInTransitListLabel' | translate}}">
                      <ng-container *ngFor="let e of estimations;  let i = index">
                        <div class="flex flex-column align-content-center">
                          <span class="estimation-text align-content-center">{{e.transitTime}}
                            <p-tag class="estimation-tag" *ngIf="i == 0" severity="success" value="Best Deal"/>
                          </span>
                        </div>
                      </ng-container>
                    </p-fieldset>
                  </div>
                  <div class="col-12 md:col-12 lg:col-4">
                    <p-fieldset class="estimation-field" legend="Ocean Freight">
                      <ng-container *ngFor="let e of estimations;  let i = index">
                        <div class="flex flex-column align-content-center">
                          <span class="estimation-text align-content-center align-items-center" >{{e.rate | currency: 'USD':'US$'}}
                            <p-tag class="estimation-tag" *ngIf="i == 0" severity="success" value="Best Deal"/>
                          </span>
                        </div>
                      </ng-container>
                    </p-fieldset>
                  </div>
                </div>
              </form>
            </div>

            <div class="col-12 md:col-6 lg:col-6 pb-0">
              <div class="p-fluid grid">
                <div class="col-12 md:col-12 lg:col-8">
                  <span class="p-input-icon-left">
                    <i class="custom-input-icon pi pi-search"></i>
                    <input type="text" pInputText (input)="filterGlobal($event)"
                      placeholder="{{'MarketplacePage.Spot.SearchProducts' | translate}}"
                      class="custom-input w-full" />
                  </span>
                </div>
                <div class="col-12 md:col-12 lg:col-4">
                  <span class="p-float-label">
                    <p-dropdown
                      id="viewAs"
                      [(ngModel)]="viewType"
                      [options]="viewTypeOptions"
                      optionLabel="label"
                      placeholder="{{'MarketplacePage.Spot.ViewLikeLabel' | translate}}"
                      optionValue="value"
                      class="p-inputtext-sm custom-dropdown bg-form"
                    />
                    <label for="viewAs" class="export-from-label">
                      {{'MarketplacePage.Spot.ViewLikeLabel' | translate}}
                    </label>
                  </span>
                </div>
                <div class="col-12 md:col-8 lg:col-8 py-0"></div>
                <div class="col-12 md:col-12 lg:col-4" [ngClass]="{'py-0': viewType != 'cards'}">
                  <span *ngIf="viewType == 'cards'" class="p-float-label">
                    <p-dropdown
                      id="orderBy"
                      (onChange)="onSortChange($event)"
                      [options]="sortOptions"
                      placeholder="{{'MarketplacePage.Spot.OrderByLabel' | translate}}"
                      class="p-inputtext-sm custom-dropdown bg-form"
                    />
                    <label for="orderBy" class="export-from-label">
                      {{'MarketplacePage.Spot.OrderByLabel' | translate}}
                    </label>
                  </span>
                </div>
                <div class="col-12 md:col-8 lg:col-8 py-0"></div>
                <div class="col-12 md:col-12 lg:col-4 justify-content-center py-2">
                  <p-button *ngIf="profile?.profileType === 'Importer'"
                    pRipple (onClick)="goToOrders()"
                    class="filter-action-button container-button"
                  >
                    <i class="material-symbols-outlined text-xl mr-2">width_normal</i>
                    <span>{{'MarketplacePage.Spot.OrderContainers' | translate}}</span>
                  </p-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div [style]="{'margin-top': '20px'}">
          <div>
            <div id="gridView" *ngIf="viewType == 'grid'" >
              <p-table #dt1
                [value]="offers"
                dataKey="exportOffer.id"
                [paginator]="true"
                [rows]="10"
                [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10, 25, 50]"
                [loading]="loading"
                [globalFilterFields]="['exportOffer.variety.species.name', 'exportOffer.variety.name', 'exportOffer.speciesSize', 'exportOffer.fridgeStorage.contactCity']"
                responsiveLayout="stack"
                [breakpoint]="'600px'"
                class="custom-table">
                <ng-template pTemplate="header">
                  <tr class="text-center">
                    <th style="text-align:-webkit-center">
                      <div class="flex align-items-center title-column justify-content-center">
                        {{'MarketplacePage.Spot.MarketPlaceTable.CountryHeader' | translate}}
                      </div>
                    </th>
                    <th class="text-center" style="text-align:-webkit-center">
                      <div class="flex align-items-center title-column">
                        {{'MarketplacePage.Spot.MarketPlaceTable.SpecieHeader' | translate}}
                        <p-columnFilter field="exportOffer.specieName" matchMode="in" display="menu"
                          [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                          <ng-template pTemplate="header">
                            <div class="px-3 pt-3 pb-0">
                              <span class="font-bold">{{'MarketplacePage.Spot.MarketPlaceTable.SelectSpecieText' |
                                translate}}</span>
                            </div>
                          </ng-template>
                          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-multiSelect [options]="speciesFilter" [ngModel]="value"
                              placeholder="{{'MarketplacePage.Spot.MarketPlaceTable.SelectText' | translate}}"
                              (onChange)="filter($event.value)" optionValue="value"
                              optionLabel="label"></p-multiSelect>
                          </ng-template>
                        </p-columnFilter>
                      </div>
                    </th>
                    <th class="text-center" pSortableColumn="exportOffer.variety.name">
                      <div class="flex align-items-center title-column">
                        {{'MarketplacePage.Spot.MarketPlaceTable.VarietyHeader' | translate}}
                        <p-columnFilter field="exportOffer.variety.name" matchMode="in" display="menu"
                          [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                          <ng-template pTemplate="header">
                            <div class="px-3 pt-3 pb-0">
                              <span class="font-bold">{{'MarketplacePage.Spot.MarketPlaceTable.SelectVarietyText' |
                                translate}}</span>
                            </div>
                          </ng-template>
                          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-multiSelect [options]="varietiesFilter" [ngModel]="value"
                              placeholder="{{'MarketplacePage.Spot.MarketPlaceTable.SelectText' | translate}}"
                              (onChange)="filter($event.value)" optionValue="value" optionLabel="label"></p-multiSelect>
                          </ng-template>
                        </p-columnFilter>
                        <p-sortIcon field="exportOffer.variety.name"></p-sortIcon>
                      </div>
                    </th>
                    <th style="text-align:-webkit-center" pSortableColumn="exportOffer.speciesSize">
                      <div class="flex align-items-center title-column">
                        {{'MarketplacePage.Spot.MarketPlaceTable.SizeHeaderHeader' | translate}}
                        <p-columnFilter type="text" field="exportOffer.speciesSize" display="menu"
                          [showAddButton]="false" [showMatchModes]="false" [showOperator]="false"
                          [matchMode]="'contains'"></p-columnFilter>
                        <p-sortIcon field="exportOffer.speciesSize"></p-sortIcon>
                      </div>
                    </th>
                    <th style="text-align:-webkit-center">
                      <div class="flex align-items-center title-column">
                        {{'MarketplacePage.Spot.MarketPlaceTable.QualityControlHeader' | translate}}
                        <p-columnFilter type="boolean" field="exportOffer.isQualityControl" display="menu"
                          [showAddButton]="false" [showMatchModes]="false" [showOperator]="false"></p-columnFilter>
                      </div>
                    </th>
                    <th style="text-align:-webkit-center" pSortableColumn="exportOffer.harvestDate">
                      <div class="flex align-items-center title-column">
                        {{'MarketplacePage.Spot.MarketPlaceTable.HarvestDateHeader' | translate}}
                        <p-columnFilter type="date" field="exportOffer.harvestDate" [locale]="locale"
                          display="menu" [showAddButton]="false" [showMatchModes]="false"
                          [showOperator]="false" matchMode="filter-date"></p-columnFilter>
                        <p-sortIcon field="exportOffer.harvestDate"></p-sortIcon>
                      </div>
                    </th>
                    <th style="text-align:left">
                      <div class="flex align-items-center title-column">
                        {{'MarketplacePage.Spot.MarketPlaceTable.LocationHeader' | translate}}
                        <p-columnFilter type="text" field="exportOffer.fridgeStorage.contactCountry.name" display="menu"
                          [showAddButton]="false" [showMatchModes]="false" [showOperator]="false"
                          [matchMode]="'contains'"></p-columnFilter>
                      </div>
                    </th>
                    <th style="text-align:-webkit-center">
                      <div class="flex align-items-center title-column">
                        {{'MarketplacePage.Spot.MarketPlaceTable.CasePerPalletsHeader' | translate}}
                      </div>
                    </th>
                    <th style="text-align:-webkit-center" pSortableColumn="exportOffer.listPrice">
                      <div class="flex align-items- title-column">
                        {{'MarketplacePage.Spot.MarketPlaceTable.ListPrice' | translate}}
                        <p-sortIcon field="exportOffer.listPrice"></p-sortIcon>
                      </div>
                    </th>
                    <th style="text-align:-webkit-center" pSortableColumn="exportOffer.availablePallets">
                      <div class="flex align-items-center title-column">
                        {{'MarketplacePage.Spot.MarketPlaceTable.AvailablePalletsHeader' | translate}}
                        <p-sortIcon field="exportOffer.availablePallets"></p-sortIcon>
                      </div>
                    </th>
                    <th style="text-align:-webkit-center">
                      <div class="flex align-items-center title-column">
                        {{'MarketplacePage.Spot.MarketPlaceTable.PalletRequiredHeader' | translate}}
                      </div>
                    </th>
                    <th style="text-align:-webkit-center">
                      <div class="flex align-items-center title-column">
                        {{'MarketplacePage.Spot.MarketPlaceTable.TotalPriceHeader' | translate}}
                      </div>
                    </th>
                    <th style="text-align:-webkit-center" colspan="1">
                      <div class="flex align-items-center title-column">
                        {{'MarketplacePage.Spot.MarketPlaceTable.OperationHeader' | translate}}
                      </div>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-offer >
                  <tr [pSelectableRow]="offer">
                    <td style="text-align:center" [ngClass]="'td-table'">
                      <img [flag]="offer.exportOffer.fridgeStorage?.contactCountry" class="row-img" alt=""/></td>
                    <td style="text-align:center">
                      <img  [src]="offer.exportOffer.variety.urlIcon | speciesImageUrl" class="row-img" [style]="{'padding': '2px', 'border-radius': '7px'}" alt=""/>
                    </td>
                    <td style="text-align:center">{{offer.exportOffer.variety.name}}</td>
                    <td style="text-align:center">{{offer.exportOffer.speciesSize}}</td>
                    <td style="text-align:center">{{offer.exportOffer.isQualityControl ? 'Sí' : 'No'}}</td>
                    <td style="text-align:left" *ngIf="offer.exportOffer.harvestTypeId === 1">
                      {{offer.exportOffer.harvestDate | date: 'dd/MM/yyyy'}}
                    </td>
                    <td style="text-align:left" *ngIf="offer.exportOffer.harvestTypeId === 2 || offer.exportOffer.harvestTypeId === 3 ">
                      <div class="flex flex-row">
                        {{offer.exportOffer.harvestStartDate | date: 'dd/MM/yyyy'}} - {{offer.exportOffer.harvestEndDate | date: 'dd/MM/yyyy'}}
                      </div>
                    </td>
                    <td style="text-align:left">{{offer.exportOffer.fridgeStorage?.contactCity ? offer.exportOffer.fridgeStorage?.contactCity +
                      ', ' + (offer.exportOffer.fridgeStorage?.contactCountry | countryDescription) : ''}}</td>
                    <td style="text-align:center">{{offer.exportOffer.caseQuantityPerPallet}}</td>
                    <td style="text-align:center"><div>{{offer.exportOffer.listPrice | currency: 'USD':'US$'}}</div>
                        <div>
                          {{offer.exportOffer.typeSale}}
                        </div>
                      </td>
                    <td style="text-align:center">{{offer.exportOffer.availablePallets}}</td>
                    <td style="text-align:center">
                        <div style="width: 100%;">
                          <p-inputNumber [(ngModel)]="offer.requiredPallets" [showButtons]="false" [min]="0"
                            [max]="offer.exportOffer.availablePallets" [size]="2" buttonLayout="horizontal"
                            spinnerMode="horizontal" [step]="1" (onInput)="getTotalPrice(offer, $event)"
                            (onBlur)="getTotalPrice(offer, $event)"
                            class="p-input-table"
                            [disabled]="profile?.profileType === 'Exporter' || portFormGroup.controls['countryFromId'].invalid || portFormGroup.controls['portToId'].invalid || portFormGroup.controls['countryToId'].invalid"
                            class="input-number input-number-price"/>
                        </div>
                    </td>
                    <td style="text-align:center"><span style="font-weight: bold;">{{offer.totalPrice | currency: 'USD':'US$'}}</span></td>
                    <td style="text-align:center">
                      <div class="flex justify-content-center gap-1">
                        <p-button
                          icon="pi pi-shopping-cart" [pTooltip]="'MarketplacePage.Spot.MarketPlaceTable.TooltipCar' | translate"
                          tooltipPosition="bottom"
                          (onClick)="createOrderFromList(offer)"
                          class="custom-table-button purchase-button"
                          [disabled]="profile?.profileType === 'Exporter' || portFormGroup.controls['countryFromId'].invalid ||
                            portFormGroup.controls['portToId'].invalid ||
                            portFormGroup.controls['countryToId'].invalid ||
                            !offer.allowPurchase"
                          >
                        </p-button>

                        <p-button
                          icon="pi pi-eye" [pTooltip]="'MarketplacePage.Spot.MarketPlaceTable.TooltipSeeDetail' | translate" tooltipPosition="left"
                          tooltipPosition="bottom"
                          class="button-table"
                          (onClick)="showOfferDetailDialog2(offer)"
                          class="custom-table-button"
                          [disabled]="portFormGroup.controls['countryFromId'].invalid || portFormGroup.controls['portToId'].invalid || portFormGroup.controls['countryToId'].invalid">
                        </p-button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="18">{{'MarketplacePage.Spot.MarketPlaceTable.EmptyResultsText' | translate}}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
          <div id="cardView" *ngIf="viewType == 'cards'">
            <p-dataView #dvViewCards [value]="offers" layout="grid" [rows]="8" [loading]="loading" [paginator]="true"
              emptyMessage="{{'MarketplacePage.Spot.MarketPlaceTable.EmptyResultsText' | translate}}"
              [sortField]="sortField" [sortOrder]="sortOrder" [loading]="loading">
              <ng-template let-offer pTemplate="gridItem">
                <div class="col-12 sm:col-6 lg:col-4 xl:col-3 py-2 px-3">
                  <app-product-card
                    class="w-full"
                    [offer]="offer.exportOffer"
                    (navigateTo)="showOfferDetailDialog2(offer)"
                  />
                </div>
              </ng-template>
            </p-dataView>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel #wishList header="{{'MarketplacePage.WishList.TabPanelHeader' | translate}}" [style]="{'background-color': '#F4F4F4'}" >
        <div>
          <div class="marketplace-filters-container">
            <form [formGroup]="importRequestForm">
              <div class="grid p-fluid align-items-center">
                <div class="col-12 md:col-2 lg:col-2">
                  <span class="p-float-label">
                    <p-dropdown class="p-dropdown"
                      [options]="species"
                      id="speciesId"
                      formControlName="speciesId"
                      optionLabel="nameEs"
                      optionValue="id"
                      (onChange)="loadVarieties()"
                      [filter]="true"
                      filterBy="name"
                      [showClear]="true"
                      placeholder="{{'MarketplacePage.WishList.EspecieFieldLabel' | translate}}"
                      class="p-inputtext-sm custom-dropdown bg-form">
                      <ng-template pTemplate="selectedItem">
                        <div class="flex align-items-center gap-2" *ngIf="selectedSpecies">
                            <img [src]="selectedSpecies.imageUrl | speciesImageUrl" class="country-img-select" alt=""/>
                            <div>{{ getSpeciesName(selectedSpecies) }}</div>
                        </div>
                      </ng-template>
                      <ng-template let-specie pTemplate="item">
                          <div class="flex align-items-center gap-2">
                              <img [src]="specie.imageUrl | speciesImageUrl" class="country-img-select" alt=""/>
                              <div>{{ getSpeciesName(specie) }}</div>
                          </div>
                      </ng-template>
                    </p-dropdown>
                    <label for="speciesId" class="export-from-label">
                      {{'MarketplacePage.WishList.EspecieFieldLabel' | translate}}
                    </label>
                  </span>
                </div>
                <div class="col-12 md:col-2 lg:col-2">
                  <span class="p-float-label">
                    <p-dropdown class="p-dropdown"
                      [options]="varieties"
                      id="varietyId"
                      formControlName="varietyId"
                      optionLabel="name"
                      optionValue="id"
                      [filter]="true"
                      filterBy="name"
                      [showClear]="true"
                      placeholder="{{'MarketplacePage.WishList.VarietyFieldLabel' | translate}}"
                      class="p-inputtext-sm custom-dropdown bg-form"
                      (onChange)="onChangeVariety()">
                      <ng-template pTemplate="selectedItem">
                        <div class="flex align-items-center gap-2" *ngIf="selectedVariety">
                          <img [src]="selectedVariety.urlIcon | speciesImageUrl" class="country-img-select" alt=""/>
                          <div>{{ selectedVariety.name }}</div>
                        </div>
                      </ng-template>
                      <ng-template let-variety pTemplate="item">
                          <div class="flex align-items-center gap-2">
                              <img [src]="variety.urlIcon | speciesImageUrl" class="country-img-select" alt=""/>
                              <div>{{ variety.name }}</div>
                          </div>
                      </ng-template>
                    </p-dropdown>
                    <label for="varietyId" class="export-from-label">
                      {{'MarketplacePage.WishList.VarietyFieldLabel' | translate}}
                    </label>
                  </span>
                </div>
                <div class="col-12 md:col-3 lg:col-2">
                  <span class="p-float-label">
                    <p-inputNumber id="week" formControlName="week" [showButtons]="true" [useGrouping]="false" [min]="1"
                      [max]="52" placeholder="{{'MarketplacePage.WishList.WeekFieldPlaceholder' | translate}}"
                      class="p-inputtext-sm input-number"
                    />
                    <label for="week" class="export-from-label">
                      {{'MarketplacePage.WishList.WeekFieldLabel' | translate}}
                    </label>
                  </span>
                </div>
                <div class="col-12 md:col-2 lg:col-2">
                  <span class="p-float-label">
                    <p-dropdown  class="p-inputtext-sm"
                      [options]="originCountriesOptions"
                      id="countryFromIdImporter"
                      formControlName="countryFromId"
                      optionLabel="name"
                      optionValue="id"
                      [filter]="true"
                      filterBy="name"
                      [showClear]="true"
                      (onChange)="onChangeImportRequestCountryFrom()"
                      class="p-inputtext-sm custom-dropdown bg-form">
                      <ng-template pTemplate="selectedItem">
                        <div class="flex align-items-center gap-2" *ngIf="selectedImportRequestCountryFrom">
                          <img [flag]="selectedImportRequestCountryFrom.code"
                            class="country-img-select" alt=""/>
                          <div>{{ selectedImportRequestCountryFrom | countryDescription }}</div>
                        </div>
                        <div class="flex align-items-center gap-2" *ngIf="!selectedImportRequestCountryFrom">
                          <img [src]="'../../../../assets/img/flags/WORLD.png'"
                            class="country-img-select" alt=""/>
                          <div>{{ allCountriesText }}</div>
                        </div>
                      </ng-template>
                      <ng-template let-country pTemplate="item">
                        <div class="flex align-items-center gap-2">
                          <img [flag]="country"
                            class="country-img-select" alt=""/>
                          <div>{{ country | countryDescription }}</div>
                        </div>
                      </ng-template>
                    </p-dropdown>
                    <label for="countryFromIdImporter" class="export-from-label">
                      {{'MarketplacePage.WishList.OriginCountryImporterPlaceholder' | translate}}
                    </label>
                  </span>
                </div>
                <div class="col-12 md:col-2 lg:col-2">
                  <span class="p-float-label">
                    <p-dropdown class="p-inputtext-sm"
                      [options]="destinationCountries"
                      id="countryToIdImporter"
                      formControlName="countryToId"
                      optionLabel="name"
                      optionValue="id"
                      (onChange)="loadImportRequests()"
                      [filter]="true"
                      filterBy="name"
                      [showClear]="true"
                      placeholder="{{'MarketplacePage.WishList.DestinationCountryFieldPlaceholder' | translate}}"
                      class="p-inputtext-sm custom-dropdown bg-form">
                      <ng-template pTemplate="selectedItem">
                        <div class="flex align-items-center gap-2" *ngIf="selectedImportRequestCountryTo">
                          <img [flag]="selectedImportRequestCountryTo.code" class="country-img-select" alt=""/>
                          <div>{{ selectedImportRequestCountryTo | countryDescription }}</div>
                        </div>
                      </ng-template>
                      <ng-template let-country pTemplate="item">
                        <div class="flex align-items-center gap-2">
                          <img [flag]="country" class="country-img-select" alt=""/>
                          <div>{{ country | countryDescription }}</div>
                        </div>
                      </ng-template>
                    </p-dropdown>
                    <label for="countryToIdImporter" class="export-from-label">
                      {{'MarketplacePage.WishList.DestinationCountryFieldPlaceholder' | translate}}
                    </label>
                  </span>
                </div>
                <div class="col-12 md:col-4 lg:col-4 xl:col-2 flex align-items-center">
                  <div class="flex justify-content-start align-items-center gap-3 w-full">
                    <p-button
                      (onClick)="loadImportRequests()"
                      styleClass="p-button-sm"
                      class="filter-action-button search-button search-clear-button">
                      <i class="pi pi-search mr-2"></i>
                      <span>{{'MarketplacePage.WishList.SearchImporterButton' | translate}}</span>
                    </p-button>

                    <p-button
                      (onClick)="clearImportRequestSearchParams()"
                      styleClass="p-button-outlined p-button-sm"
                      class="filter-action-button clear-button search-clear-button">
                      <span>{{'MarketplacePage.WishList.ClearFilterImporterButton' | translate}}</span>
                    </p-button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div [style]="{'margin-top': '20px'}">
            <div>
              <div id="gridViewImportRequest">
                <p-table
                  #dt2
                  [value]="requests"
                  dataKey="importRequest.id"
                  [paginator]="true"
                  [rows]="10"
                  [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[10, 25, 50]"
                  [loading]="loadingImportRequest"
                  [scrollable]="true"
                  responsiveLayout="stack"
                  [breakpoint]="'600px'"
                  class="custom-table"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th>
                        <div class="flex justify-content-center aling-items-center">
                          {{'MarketplacePage.WishList.WishListTable.CountryHeader' | translate}}
                        </div>
                      </th>
                      <th>
                        <div class="flex justify-content-center aling-items-center">
                          {{'MarketplacePage.WishList.WishListTable.SpecieHeader' | translate}}
                        </div>
                      </th>
                      <th>
                        <div class="flex justify-content-center aling-items-center">
                          {{'MarketplacePage.WishList.WishListTable.VarietyHeader' | translate}}
                        </div>
                      </th>
                      <th>
                        <div class="flex justify-content-center align-items-center">
                          {{'MarketplacePage.WishList.WishListTable.SpeciesSizeHeader' | translate}}
                        </div>
                      </th>
                      <th>
                        <div class="flex justify-content-center align-items-center">
                          {{'MarketplacePage.WishList.WishListTable.WeekRangeHeader' | translate}}
                        </div>
                      </th>
                      <th>
                        <div class="flex justify-content-center align-items-center">
                          {{'MarketplacePage.WishList.WishListTable.IncotermsHeder' | translate}}
                        </div>
                      </th>
                      <th>
                        <div class="flex justify-content-center align-items-center">
                          {{'MarketplacePage.WishList.WishListTable.TotalPalletsHeader' | translate}}
                        </div>
                      </th>
                      <th>
                        <div class="flex justify-content-center align-items-center">
                          {{'MarketplacePage.WishList.WishListTable.TotalContainerHeader' | translate}}
                        </div>
                      </th>
                      <th>
                        <div class="flex justify-content-center align-items-center">
                          {{'MarketplacePage.WishList.WishListTable.PricePerCase' | translate}}
                        </div>
                      </th>
                      <th colspan="2">
                        <div class="flex justify-content-center align-items-center">
                          {{'MarketplacePage.WishList.WishListTable.OperationHeader' | translate}}
                        </div>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-request>
                    <tr [pSelectableRow]="request">
                      <td>
                        <div class="flex justify-content-center align-items-center">
                          <img [flag]="request.importRequest.country"
                            height="48px" width="48px" alt=""/>
                        </div>
                      </td>
                      <td>
                        <div class="flex justify-content-center align-items-center">
                          <img [src]="request.importRequest.variety.urlIcon | speciesImageUrl" width="50px" height="50px"
                            style="padding: 2px; border-radius: 7px;" alt=""/>
                        </div>
                      </td>
                      <td>
                        <div class="flex justify-content-center align-items-center">
                          {{request.importRequest.variety.name}}
                        </div>
                      </td>
                      <td>
                        <div class="flex justify-content-center align-items-center">
                          {{request.importRequest.speciesSize}}
                        </div>
                      </td>
                      <td>
                        <div class="flex justify-content-center align-items-center flex-column">
                          <span>
                            {{ request.importRequest.fromWeek }} ({{request.importRequest.fromYearWeek }}) -
                            {{request.importRequest.toWeek}} ({{request.importRequest.toYearWeek }})
                          </span>
                          <span class="week-style">
                            {{getTotalWeeksImportRequest(request.importRequest)}}
                            {{'MarketplacePage.WishList.WishListTable.WeekLabel' | translate }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="flex justify-content-center align-items-center">
                          <span class="incoterms-tag">{{request.importRequest.typeSale}}</span>
                        </div>
                      </td>
                      <td>
                        <div class="flex justify-content-center align-items-center">
                          {{getTotalPalletsImportRequest(request.importRequest)}}
                        </div>
                      </td>
                      <td>
                        <div class="flex justify-content-center align-items-center">
                          {{getTotalContainersImportRequest(request.importRequest)}}
                        </div>
                      </td>
                      <td>
                        <div class="flex justify-content-center align-items-center">
                          {{request.importRequest.pricePerCase | currency: 'USD':'US$'}}
                        </div>
                      </td>
                      <td>
                        <div class="flex justify-content-center align-items-center">
                          <p-button
                            *ngIf="request.importRequest.guid"
                            class="custom-table-button purchase-button"
                            styleClass="p-button-sm"
                            icon="pi pi-shopping-cart"
                            pTooltip="{{'MarketplacePage.WishList.WishListTable.ButtonModal' | translate}}"
                            tooltipPosition="bottom"
                            (onClick)="goToImportRequesDetail(request.importRequest.guid)"
                          />
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="6">{{'MarketplacePage.WishList.WishListTable.EmptyResultsText' | translate}}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</app-user-dashboard>



<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleImportRequestDialog" [style]="{width: '70%'}">
  <div *ngIf="selectedImportRequest">
    <div class="grid">
      <div class="col-4">
        <p-carousel [value]="selectedImportRequest.pictures" [numVisible]="1" [numScroll]="1" [circular]="false"
          [responsiveOptions]="responsiveOptions">
          <ng-template let-picture pTemplate="item">
            <div class="mb-3" style="height: 50%;">
              <img [src]="completeUrl(picture.url)" style="border-radius: 7px; width: 100%; height: auto;"
                alt="Image" />
            </div>
          </ng-template>
        </p-carousel>
      </div>
      <div class="col-8">
        <div class="grid">
          <div class="col-12">
            <p-card header="{{'MarketplacePage.WishList.ImportRequestModal.CardTitle' | translate}}">
              <div class="grid">
                <div class="col-12">
                  <p-fieldset legend="{{'MarketplacePage.WishList.ImportRequestModal.FieldSetLegend' | translate}}">
                    <p-dropdown [options]="requestOffers" [(ngModel)]="selectedOffer" placeholder="{{'MarketplacePage.WishList.ImportRequestModal.OfferSelectFieldPlaceholder' | translate}}"
                      optionLabel="name" [filter]="true" filterBy="name" [showClear]="true"
                      [style]="{'minWidth':'100%'}" class="p-inputtext-sm">
                    </p-dropdown>
                  </p-fieldset>
                </div>
                <div *ngIf="selectedOffer" class="col-12">
                  <div class="grid">
                    <div class="col-12">
                      <h2>{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.Title' | translate}}</h2>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.SpeciesLabel' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{ selectedOffer.exportOffer.variety.species | speciesName }}</span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.VarietyLabel' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{ selectedOffer.exportOffer.variety.name }}</span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.CasePerPalletsText' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                        selectedOffer.exportOffer.caseQuantityPerPallet }}</span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.ListPriceText' | translate}}</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                        selectedOffer.exportOffer.listPrice | currency: 'USD':'US$' }}</span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.AvailablePalletsText' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                        selectedOffer.exportOffer.availablePallets }}</span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">Shelf life:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                        selectedOffer.exportOffer.shelfLife }} {{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.DayShelflifeText' | translate}}</span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.ColorText' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{ selectedOffer.exportOffer.color | colorName }}</span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.SpeciesSizeText' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                        selectedOffer.exportOffer.speciesSize }}</span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.SpeciesSizeMillimetersFieldText' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                        selectedOffer.exportOffer.sizeMillimeters }} mm</span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.CategoryText' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                        selectedOffer.exportOffer.category }}</span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.NetKilosLabel' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                        selectedOffer.exportOffer.netKilos }} Kg</span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.CountryText' | translate}}</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{selectedOffer.exportOffer.country | countryDescription }}</span>
                    </div>
                  </div>
                  <div class="grid" style="margin-top: 20px;">
                    <div class="col-12 md:col-6 lg:col-6">{{'ExportOffer.ExportOfferDetail.AvailableProductCertificates' | translate}}:</div>
                    <div class="col-12 md:col-6 lg:col-6">
                      <ul *ngIf="selectedOffer.exportOffer.productCertificateTypes.length > 0">
                        <ng-container *ngFor="let productCertificateType of selectedOffer.exportOffer.productCertificateTypes">
                          <!-- <li>{{ productCertificateType.name }}&nbsp;<span *ngIf="productCertificateType.isOther" style="font-weight: bolder;">{{ selectedOffer.exportOffer.otherCertificateType }}</span></li> -->
                          <li *ngIf="!productCertificateType.isOther">{{ productCertificateType.name }}</li>
                          <li *ngIf="productCertificateType.isOther">{{ selectedOffer.exportOffer.otherCertificateType }}</li>
                        </ng-container>
                      </ul>
                      <span *ngIf="selectedOffer.exportOffer.productCertificateTypes.length == 0" style="font-weight: bolder;">{{ 'UserPages.UserExportOffers.NotResultsMessages' | translate }}</span>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">{{'ExportOffer.ExportOfferDetail.AvailablePackaging' | translate}}:</div>
                    <div class="col-12 md:col-6 lg:col-6">
                      <ul *ngIf="selectedOffer.exportOffer.packagingTypes.length > 0">
                        <ng-container *ngFor="let packagingType of selectedOffer.exportOffer.packagingTypes">
                          <!-- <li>{{ packagingType.name }}&nbsp;<span *ngIf="packagingType.isOther" style="font-weight: bolder;">{{ selectedOffer.exportOffer.otherPackaging }}</span></li> -->
                          <li *ngIf="!packagingType.isOther">{{ packagingType.name }}</li>
                          <li *ngIf="packagingType.isOther">{{ selectedOffer.exportOffer.otherPackaging }}</li>
                        </ng-container>
                      </ul>
                      <span *ngIf="selectedOffer.exportOffer.packagingTypes.length == 0" style="font-weight: bolder;">{{ 'UserPages.UserExportOffers.NotResultsMessages' | translate }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-12" style="margin-top: 20px;">
                  <div class="grid" >
                    <div class="col-12">
                      <h2>{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.Title' | translate}}</h2>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.SpeciesLabel' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">
                        {{ selectedImportRequest.importRequest.variety.species | speciesName }}
                      </span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.VarietyText' | translate}}</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">
                        {{selectedImportRequest.importRequest.variety.name }}
                      </span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.SellTypeText' | translate}}</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">
                        {{ selectedImportRequest.importRequest.typeSale }}
                      </span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.CasePerPalletsText' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">
                        {{ selectedImportRequest.importRequest.caseQuantityPerPallet }}
                        </span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.PricePerCase' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                        selectedImportRequest.importRequest.pricePerCase | currency: 'USD':'US$' }}
                      </span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.SpeciesSizeText' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">
                        {{selectedImportRequest.importRequest.speciesSize }}
                      </span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.BoxTypeText' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">
                        {{ getBoxType((selectedImportRequest.importRequest.boxType)) }}
                      </span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.DestinationPortText' | translate}}:</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">
                        {{selectedImportRequest.importRequest.port.name }}
                      </span>
                    </div>
                    <!-- <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.PaymentAgainstBLLabel' | translate}}:</div> -->
                    <div class="col-12 md:col-3 lg:col-3">{{ paymentBLTitleImportRequest | translate }}</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">
                        {{selectedImportRequest.importRequest.paymentAgainstBL }} %
                      </span>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">{{'ExportOffer.ExportOfferDetail.FinalPaymentSubjectQC' | translate}}</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{ finalPaymentSubjectQC }} %</span>
                    </div>

                    <div *ngIf="selectedImportRequest.importRequest?.countryFrom !== null" class="col-12 md:col-3 lg:col-3">{{'ExportOffer.ExportOfferDetail.OriginCountryText' | translate}}</div>
                    <div *ngIf="selectedImportRequest.importRequest?.countryFrom === null" class="col-12 md:col-3 lg:col-3">{{'ImportRequestDetailComponent.OriginCountryAll' | translate }}</div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <div class="flex align-items-center">
                        <img *ngIf="selectedImportRequest.importRequest?.countryFrom !== null" [flag]="selectedImportRequest.importRequest.countryFrom?.code" style="width: 18px" alt=""/> {{selectedImportRequest.importRequest.countryFrom | countryDescription}}
                        <img *ngIf="selectedImportRequest.importRequest?.countryFrom === null" [src]="'../../../../assets/img/flags/WORLD.png'" style="width: 18px" alt=""/>
                      </div>
                    </div>

                    <div *ngIf="selectedImportRequest.importRequest?.country" class="col-12 md:col-3 lg:col-3">{{'ExportOffer.ExportOfferDetail.DestinationCountryText' | translate}}</div>
                    <div *ngIf="selectedImportRequest.importRequest?.country" class="col-12 md:col-3 lg:col-3">
                      <div class="flex align-items-center">
                        <img [flag]="selectedImportRequest.importRequest.country?.code" style="width: 18px" alt=""/> {{selectedImportRequest.importRequest.country ? (selectedImportRequest.importRequest.country | countryDescription) : getAvailableLabel()}}
                      </div>
                    </div>

                  </div>

                  <div class="grid" style="margin-top: 20px;">
                    <div class="col-12 md:col-6 lg:col-6">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.RequiredProductCertificatesLabel' | translate}}:</div>
                    <div class="col-12 md:col-6 lg:col-6">
                      <ul *ngIf="selectedProductCertificateTypes.length > 0">
                        <ng-container *ngFor="let productCertificateType of selectedProductCertificateTypes">
                          <!-- <li>{{ productCertificateType.name }}&nbsp;<span *ngIf="productCertificateType.isOther" style="font-weight: bolder;">{{ selectedImportRequest.importRequest.otherCertificate }}</span></li> -->
                          <li *ngIf="!productCertificateType.isOther">{{ productCertificateType.name }}</li>
                          <li *ngIf="productCertificateType.isOther">{{ selectedImportRequest.importRequest.otherCertificate }}</li>
                        </ng-container>
                      </ul>
                      <span *ngIf="selectedProductCertificateTypes.length == 0" style="font-weight: bolder;">{{ 'UserPages.UserExportOffers.NotResultsMessages' | translate }}</span>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.RequiredPackagingLabel' | translate}}:</div>
                    <div class="col-12 md:col-6 lg:col-6">
                      <ul *ngIf="selectedPackagingTypes.length > 0">
                        <ng-container *ngFor="let packagingType of selectedPackagingTypes">
                          <!-- <li>{{ packagingType.name }}&nbsp;<span *ngIf="packagingType.isOther" style="font-weight: bolder;">{{ selectedImportRequest.importRequest.otherPackaging }}</span></li> -->
                          <li *ngIf="!packagingType.isOther">{{ packagingType.name }}</li>
                          <li *ngIf="packagingType.isOther">{{ selectedImportRequest.importRequest.otherPackaging }}</li>
                        </ng-container>
                      </ul>
                      <span *ngIf="selectedPackagingTypes.length == 0" style="font-weight: bolder;">{{ 'UserPages.UserExportOffers.NotResultsMessages' | translate }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </p-card>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button label="{{'MarketplacePage.WishList.ImportRequestModal.CloseButton' | translate}}" (onClick)="closeOfferToRequestDialog()" styleClass="p-button-outlined"></p-button>
    <p-button label="{{'MarketplacePage.WishList.ImportRequestModal.SendButton' | translate}}" (onClick)="sendOfferToRequest()"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleOfferDetailDialog"
  [style]="{width: '80%', heigth: 'auto'}">
  <div *ngIf="selected && selected.exportOffer">
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
        <app-export-offer-detail-carousel [offer]="selected.exportOffer"></app-export-offer-detail-carousel>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <p-card [header]="getHeader(selected.exportOffer)" [subheader]="getSubheader(selected.exportOffer)">
          <div class="flex justify-content-between align-items-center" *ngIf="profile?.profileType === 'Importer'">
            <p style="font-size: 1.5rem; color: #8c2b87; font-weight: bold;">{{'MarketplacePage.WishList.ExportOfferModal.TotalUpperCaseText' | translate}} {{ totalPrice | currency: 'USD':'US$'}}
              {{getIncoterms(selected.exportOffer.typeSale)}}</p>
          </div>
          <div class="grid" style="margin-top: 30px;">
            <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ExportOfferModal.CasePerPalletsText' | translate}}:</div>
            <div class="col-12 md:col-3 lg:col-3">
              <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                selected.exportOffer.caseQuantityPerPallet }}</span>
            </div>
            <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ExportOfferModal.ListPriceText' | translate}}</div>
            <div class="col-12 md:col-3 lg:col-3">
              <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                selected.exportOffer.listPrice | currency: 'USD':'US$' }} {{selected.exportOffer.typeSale}}</span>
            </div>
            <div class="col-12 md:col-3 lg:col-3">{{'ExportOffer.ExportOfferDetail.PaymentAgainstBLLabel' | translate}}</div>
            <div class="col-12 md:col-3 lg:col-3">
              <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{ selected.exportOffer.paymentAgainstBL }} %</span>
            </div>
            <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ExportOfferModal.AvailablePalletsText' | translate}}:</div>
            <div class="col-12 md:col-3 lg:col-3">
              <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{ availablePallets }}</span>
            </div>
            <div class="col-12 md:col-3 lg:col-3">Shelf Life:</div>
            <div class="col-12 md:col-3 lg:col-3">
              <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{ selected.exportOffer.shelfLife ? selected.exportOffer.shelfLife +  " " + translate.instant('MarketplacePage.WishList.ExportOfferModal.DayShelflifeText') : getNoAvailableLabel() }}</span>
            </div>
            <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ExportOfferModal.ColorText' | translate}}:</div>
            <div class="col-12 md:col-3 lg:col-3">
              <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                selected.exportOffer.color ? getColor(selected.exportOffer.color) : getNoAvailableLabel()}}</span>
            </div>
            <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ExportOfferModal.NetKilosText' | translate}}:</div>
            <div class="col-12 md:col-3 lg:col-3">
              <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                selected.exportOffer.netKilos ? selected.exportOffer.netKilos + ' Kg.' : getNoAvailableLabel() }}</span>
            </div>
            <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ExportOfferModal.GrossKilosText' | translate}}:</div>
            <div class="col-12 md:col-3 lg:col-3">
              <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                selected.exportOffer.grossKilos ? selected.exportOffer.grossKilos + ' Kg.' : getNoAvailableLabel() }}</span>
            </div>
            <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ExportOfferModal.SpeciesSizeText' | translate}}:</div>
            <div class="col-12 md:col-3 lg:col-3">
              <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                selected.exportOffer.speciesSize ? selected.exportOffer.speciesSize : getNoAvailableLabel() }}</span>
            </div>
            <div class="col-12 md:col-3 lg:col-3">{{'MarketplacePage.WishList.ExportOfferModal.TypeSaleText' | translate}}:</div>
            <div class="col-12 md:col-3 lg:col-3">
              <span style="border-radius: 7px; padding: 5px; font-weight: bold;">{{
                selected.exportOffer.typeSale ? selected.exportOffer.typeSale : getNoAvailableLabel() }}</span>
            </div>
          </div>

          <div class="grid" style="margin-top: 10px;">
            <div class="col-12 md:col-6 lg:col-6">{{'ExportOffer.ExportOfferDetail.AvailableProductCertificates' | translate}}:</div>
            <div class="col-12 md:col-6 lg:col-6">
              <ul *ngIf="selectedProductCertificateTypes.length > 0">
                <ng-container *ngFor="let productCertificateType of selectedProductCertificateTypes">
                  <!-- <li>{{ productCertificateType.name }}&nbsp;<span *ngIf="productCertificateType.isOther" style="font-weight: bolder;">{{ selected.exportOffer.otherCertificateType }}</span></li> -->
                  <li *ngIf="!productCertificateType.isOther">{{ productCertificateType.name }}</li>
                  <li *ngIf="productCertificateType.isOther">{{ selected.exportOffer.otherCertificateType }}</li>
                </ng-container>
              </ul>
              <span *ngIf="selectedProductCertificateTypes.length == 0" style="font-weight: bolder;">{{ 'UserPages.UserExportOffers.NotResultsMessages' | translate }}</span>
            </div>
            <div class="col-12 md:col-6 lg:col-6">{{'ExportOffer.ExportOfferDetail.AvailablePackaging' | translate}}:</div>
            <div class="col-12 md:col-6 lg:col-6">
              <ul *ngIf="selectedPackagingTypes.length > 0">
                <ng-container *ngFor="let packagingType of selectedPackagingTypes">
                  <!-- <li>{{ packagingType.name }}&nbsp;<span *ngIf="packagingType.isOther" style="font-weight: bolder;">{{ selected.exportOffer.otherPackaging }}</span></li> -->
                  <li *ngIf="!packagingType.isOther">{{ packagingType.name }}</li>
                  <li *ngIf="packagingType.isOther">{{ selected.exportOffer.otherPackaging }}</li>
                </ng-container>
              </ul>
              <span *ngIf="selectedPackagingTypes.length == 0" style="font-weight: bolder;">{{ 'UserPages.UserExportOffers.NotResultsMessages' | translate }}</span>
            </div>
          </div>

          <div class="p-fluid formgrid grid align-items-end" *ngIf="profile?.profileType === 'Importer'"
            style="margin-top: 30px;">
            <div class="col-12">
              <h2>{{'MarketplacePage.WishList.ExportOfferModal.PurchaseForm.Title' | translate}}</h2>
            </div>
            <div class="field col-12 md:col-12 lg:col-6">
              <label for="pallets">Pallets</label>
              <p-inputNumber inputId="pallets" [(ngModel)]="pallets" [showButtons]="false" [min]="1"
                [max]="selected.exportOffer.availablePallets" [size]="2" buttonLayout="horizontal"
                spinnerMode="horizontal" [step]="1" decrementButtonClass="p-button-outlined"
                incrementButtonClass="p-button-outlined" incrementButtonIcon="pi pi-plus"
                decrementButtonIcon="pi pi-minus" (onInput)="getTotalPriceOfferDialog(selected.exportOffer, $event)"
                class="p-inputtext-sm"></p-inputNumber>
            </div>
            <div class="field col-12 md:col-12 lg:col-6">
              <p-button label="{{'MarketplacePage.WishList.ExportOfferModal.PurchaseForm.PurchaseNowButton' | translate}}" (onClick)="createOrder()" [loading]="loading"></p-button>
            </div>
          </div>

          <form [formGroup]="negotiationFormGroup" *ngIf="profile?.profileType === 'Importer'"
            style="margin-top: 30px;">
            <div class="grid">
              <div class="col-12">
                <h2>{{'MarketplacePage.WishList.ExportOfferModal.NegotiationFieldSetLegend' | translate}}</h2>
              </div>
              <div class="col-12">
                <div class="p-fluid formgrid grid flex align-items-start">
                  <div class="field col-12 md:col-6 lg:col-6">
                    <label for="negociation-price">{{'MarketplacePage.WishList.ExportOfferModal.NegotiationPriceFieldLable' | translate}}</label>
                    <p-inputNumber inputId="negociation-price" formControlName="negociationPrice" [min]="0"
                      mode="currency" currency="USD" locale="en-US" placeholder="{{'MarketplacePage.WishList.ExportOfferModal.NegotiationPriceFieldPlaceholder' | translate}}"
                      class="p-inputtext-sm"></p-inputNumber>
                    <small *ngIf="submitNegotiation && negotiationFormGroup.controls['negociationPrice'].invalid"
                      class="p-error">{{getErrorMessage('negociationPrice')}}</small>
                  </div>
                  <div class="field col-12 md:col-6 lg:col-6">
                    <label for="negotiation-pallets">{{'MarketplacePage.WishList.ExportOfferModal.PalletsFieldLabel' | translate}}</label>
                    <p-inputNumber inputId="negotiation-pallets" formControlName="negociationPallets" [min]="1"
                      [max]="selected.exportOffer.availablePallets" class="p-inputtext-sm"></p-inputNumber>
                    <small *ngIf="submitNegotiation && negotiationFormGroup.controls['negociationPallets'].invalid"
                      class="p-error">{{getErrorMessage('negociationPallets')}}</small>
                  </div>
                  <div class="field col-12 md:col-6 lg:col-6">
                    <label for="negociation-incoterm">{{'MarketplacePage.WishList.ExportOfferModal.SellModeFieldLabel' | translate}}</label>
                    <p-dropdown inputId="negociation-incoterm" formControlName="negociationIncoterm"
                      (onChange)="onChangeIncoterm($event)" [options]="incotermsOptions" optionLabel="label" optionValue="value"
                      placeholder="{{'MarketplacePage.WishList.ExportOfferModal.SellModeFieldPlaceholder' | translate}}" appendTo="body" class="p-inputtext-sm"></p-dropdown>
                    <small *ngIf="submitNegotiation && negotiationFormGroup.controls['negociationIncoterm'].invalid" class="p-error">{{getErrorMessage('negociationIncoterm')}}</small>
                  </div>
                  <div class="field col-12 md:col-6 lg:col-6">
                    <label for="negociation-paymentAgainstBL" style="font-size: calc(100% - 4px);">{{ paymentBLTitle | translate }} *</label>
                    <p-dropdown id="negociation-paymentAgainstBL" formControlName="negotiationPaymentAgainstBL" [options]="paymentBLItems" optionLabel="label" optionValue="value" placeholder="{{'UserPages.UserBargaining.OpenTab.BargainingDetail.MakeCounterOfferModal.PaymentAgainstBLLabel' | translate}}" appendTo="body"></p-dropdown>
                    <small *ngIf="submitNegotiation && negotiationFormGroup.controls['negotiationPaymentAgainstBL'].invalid" class="p-error">{{getErrorMessage('negotiationPaymentAgainstBL')}}</small>
                    <small *ngIf="showPaymentBLPercent">{{'UserPages.UserExportOffers.NewExportOffer.FinalPaymentSubjectQCReview' | translate}} {{finalPaymentPercent}}%</small>
                  </div>
                  <div class="field col-12 md:col-12 lg:col-12">
                    <label>&nbsp;</label>
                    <p-button label="{{'MarketplacePage.WishList.ExportOfferModal.CreateNegotiationButton' | translate}}" (onClick)="createNegotiation()" [loading]="loading" [style]="{'background-color': '#8c2b87'}"></p-button>
                    <label *ngIf="submitNegotiation && !negotiationFormGroup.valid">&nbsp;</label>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </p-card>
      </div>
    </div>
    <app-export-offer-detail-description [offer]="selected.exportOffer"></app-export-offer-detail-description>
  </div>
  <ng-template pTemplate="footer">
    <p-button label="{{'MarketplacePage.WishList.ExportOfferModal.CloseButton' | translate}}" (onClick)="closeOfferDetailDialog()"></p-button>
  </ng-template>
</p-dialog>
<app-footer-home></app-footer-home>
